import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        },
        selected: {},
    },
    getters: {
        items: state => state.items,
        selected: state => state.selected,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setSelected(state, selected) {
            state.selected = selected;
        }
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('sip/gateways', {
                params: rootState.route.query
            });

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('sip/gateways', payload);

            return response;
        },
        async update({ commit, state }, payload) {
            const response = await http.patch(`sip/gateways/${state.selected.gwid}`, payload);

            return response;
        },
        async delete({ commit, state }) {
            const response = await http.delete(`sip/gateways/${state.selected.gwid}`);

            return response;
        },
    }
}